export default "__VITE_ASSET__a8eb3029__"